import { Box, Typography } from '@mui/material';
import { Filters } from '../Filters';
import { FiltersCard } from '../Filters/FiltersCard';
import { TaskTable } from '@views/pages/Worklist/common';
import { useCompletedTasks } from './hooks';
import { IColumnDefinition } from '@common/types';
import { FactCheck } from '@mui/icons-material';
import { t } from 'i18next';
import { theme } from '@store';
import { useMyWorklistFilterStore } from 'views/pages/Worklist/MyWorklist/store/filter.store';

const columns: IColumnDefinition[] = [
  {
    id: 'task',
    label: 'Task',
    sortable: true,
  },
  {
    id: 'category',
    label: 'Category',
    sortable: true,
  },
  {
    id: 'patient',
    label: 'Patient',
    sortable: true,
  },
  {
    id: 'priority',
    label: 'Priority',
    sortable: true,
    align: 'center',
  },
  {
    id: 'due_date',
    label: 'Due date',
    sortable: true,
  },
  {
    id: 'status',
    label: 'Status',
    sortable: true,
  },
  {
    id: 'created_date',
    label: 'Created date',
    sortable: true,
  },
  {
    id: 'last_updated_at',
    label: 'Last updated',
    sortable: true,
  },
  {
    id: 'provider',
    label: 'Provider',
    sortable: true,
  },
  {
    id: 'location',
    label: 'Location',
    sortable: true,
  },
  {
    id: 'assignment',
    label: 'Assigned to',
    sortable: true,
  },
];

export const CompletedTasks = () => {
  const {
    entries,
    filters,
    totalCount,
    isLoading,
    handleOpenTaskDetails,
    handleFilterChange,
    selectedTaskId,
    isInitialFilters,
    handleResetFilters,
  } = useCompletedTasks();

  const { isFiltersCardOpen } = useMyWorklistFilterStore();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        flexDirection: 'row',
        gap: '1rem',
        width: '100%',
      }}
    >
      {isFiltersCardOpen && <FiltersCard />}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {entries.length === 0 &&
        isInitialFilters &&
        !isLoading &&
        !filters.own_tasks_only ? (
          <Box
            sx={{
              height: 'calc(100vh - 480px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: 1,
              [theme.breakpoints.down(1536)]: {
                height: 'calc(100vh - 280px)',
              },
            }}
          >
            <FactCheck sx={{ width: 56, height: 56, mb: 2 }} color='primary' />
            <Typography variant='h6'>
              {t('worklist.table.noResults.title')}
            </Typography>
            <Typography variant='body2' sx={{ color: 'text.disabled' }}>
              {t('worklist.table.noResults.subTitle')}
            </Typography>
          </Box>
        ) : (
          <>
            <Filters />
            <TaskTable
              rows={entries}
              columns={columns}
              filters={filters}
              setFilters={handleFilterChange}
              totalCount={totalCount}
              onSelectTask={handleOpenTaskDetails}
              loading={isLoading}
              selectedTaskId={selectedTaskId}
              myWorkList
              isCompletedTab
              onResetAction={handleResetFilters}
            />
          </>
        )}
      </Box>
    </Box>
  );
};
